import { Utility } from './utility'

export const TokenHelper = {
  apply: (
    content: string,
    values: Record<string, any>,
    pattern = ['{', '}'],
    strict = false,
  ) => {
    if (Utility.isNull(content)) {
      return content
    }

    if (Utility.isNull(values)) {
      return content
    }

    const valuesFlat = Utility.flattenObject(values)
    let contentUpdated = content

    const prefix = pattern[0] ?? '{'
    const suffix = pattern[1] ?? '}'

    for (const [key, value] of Object.entries(valuesFlat)) {
      const token = `${prefix}${key}${suffix}`

      if (value === null || typeof value === 'undefined') {
        if (strict) {
          throw new Error(`cannot replace token "${token}" with null value`)
        } else {
          console.warn(`cannot replace token "${token}" with null value`)
        }
      }

      contentUpdated = contentUpdated.replaceAll(token, String(value ?? 'N/A'))
    }

    return contentUpdated
  },

  areValid: (content: string, validTokens: string[], pattern = ['{', '}']) => {
    if (!content) {
      return true
    }

    const [prefix, suffix] = pattern

    const tokenRegex = new RegExp(`${prefix}[^${suffix}]+${suffix}`, 'g')

    const tokens = content.match(tokenRegex) || []

    return tokens.every(token => validTokens.includes(token))
  },

  hasRemainingTokens: (
    content: string,
    patterns = [
      ['{{', '}}'],
      ['{', '}'],
    ],
  ): { hasRemainingTokens: boolean; tokens: string[] } => {
    if (!content) {
      return { hasRemainingTokens: false, tokens: [] }
    }

    for (const [prefix, suffix] of patterns) {
      const escapedPrefix = prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
      const escapedSuffix = suffix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

      const tokenRegex = new RegExp(
        `${escapedPrefix}[^${escapedSuffix}]+${escapedSuffix}`,
        'g',
      )
      const matches = content.match(tokenRegex) || []

      if (matches.length > 0) {
        return { hasRemainingTokens: true, tokens: matches }
      }
    }

    return { hasRemainingTokens: false, tokens: [] }
  },
}
